/* eslint-disable */
import Navigation from '../components/Navigation';
import Cookies from '../components/Cookies';
import Accordion from '../components/Accordion';

export default {
    navigationInit() {
        const navigation = new Navigation;
        navigation.init();
    },

    smoothScroll() {
        $('a.smooth').bind('click', function(e) {
            e.preventDefault();

            const target = $(this).attr('href');

            $('html, body').stop().animate({
                scrollTop: $(target).offset().top - 70,
            }, 600);

            return false;
        });
    },

    modalInit() {
        $(".modal-trigger").click(function(e){
            e.preventDefault();
            const dataModal = $(this).attr("data-modal");
            $("#" + dataModal).addClass('d-block');
        });

        $('.modal-trigger-prow').click(function(e){
            e.preventDefault();
            $("#modal-prow").addClass('d-block');
        });
        
        $(".close-modal, .modal-sandbox").click(function(){
            $(".modal").removeClass('d-block');
        });
    },

    init() {
        // JavaScript to be fired on all pages
        this.navigationInit(); 
        this.smoothScroll();
        this.modalInit();

        // Accordion init
        Accordion();

        //Cookie init
        Cookies();
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js